module.exports = __webpack_public_path__ + "img/img5_5.5df13fcd.jpeg";